/** 후원(/sponsorship) 탭 메뉴 — `Sponsorship.tsx`와 동일하게 유지 */
export const SPONSORSHIP_MENU_GUIDE = '후원안내';
export const SPONSORSHIP_MENU_ANNUAL_DONATION = '연간기부금 모금액 및 활용실적';

export const SPONSORSHIP_MENU_LIST = [SPONSORSHIP_MENU_GUIDE, SPONSORSHIP_MENU_ANNUAL_DONATION] as const;
